<template>
  <div class="form-group">
    <label v-if="label" class="form-label text-muted">
      {{ label }}
      <span v-if="required" class="text-danger">*</span>
    </label>
    <div
      class="border rounded p-2"
      :class="{ 'border-danger': hasError }"
      style="max-height: 200px; overflow-y: auto;"
    >
      <div
        v-for="(item, index) in options"
        :key="'option_' + index"
        class="form-check"
      >
        <input
          class="form-check-input"
          type="checkbox"
          :id="'check_' + index"
          :value="item[propertyForValue]"
          :checked="isChecked(item[propertyForValue])"
          @change="toggleOption(item[propertyForValue])"
          :disabled="readOnly"
        />
        <label class="form-check-label" :for="'check_' + index">
          {{ item[propertyForText] }}
        </label>
      </div>
      <div v-if="!options.length" class="text-muted small">
        Nenhuma opção disponível
      </div>
    </div>
    <small v-if="helperText" class="form-text text-muted">{{ helperText }}</small>
    <div v-if="hasError" class="text-danger">
      <small>{{ errorMsg }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: "MultiSelectInput",
  props: {
    model: {
      required: false,
      default: null,
    },
    value: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    propertyForValue: {
      type: String,
      default: "id",
    },
    propertyForText: {
      type: String,
      default: "title",
    },
    label: {
      type: String,
      default: "",
    },
    errorMsg: {
      type: String,
      default: "Por favor, selecione pelo menos uma opção",
    },
    helperText: {
      type: String,
      default: "",
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isVuelidate() {
      return this.model && typeof this.model === "object" && "$model" in this.model;
    },
    internalValue: {
      get() {
        if (this.isVuelidate) {
          return this.model.$model || [];
        }
        return this.value || [];
      },
      set(newValue) {
        if (this.isVuelidate) {
          this.model.$model = newValue;
        }
        this.$emit("input", newValue);
        this.$emit("change", newValue);
      },
    },
    hasError() {
      return this.isVuelidate && this.model.$error;
    },
  },
  methods: {
    isChecked(value) {
      return this.internalValue.includes(value);
    },
    toggleOption(value) {
      const current = [...this.internalValue];
      const index = current.indexOf(value);
      if (index === -1) {
        current.push(value);
      } else {
        current.splice(index, 1);
      }
      this.internalValue = current;
    },
  },
};
</script>
